import { TranslatePipe } from 'app/pipes/translate.pipe';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { AuthenticationService } from 'app/services/authentication/authentication.service';
import { Subscription } from 'rxjs';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { OtpComponent } from './otp/otp.component';
import { DialogErrorComponent } from '../modal/dialog-error/dialog-error.component';
import { OTP_STATE } from './otp-state';
import { UserService } from 'app/services/user/user.service';
import { OTPRequest, RequestOTPResponse, VerificationMethodModel, VerifyOTPRequest } from 'app/model/otp/otp.model';
import { VerifyPINResponse } from 'app/model/pin/pin.model';

@Component({
  selector: 'act-verify-otp',
  templateUrl: './verify-otp.component.html',
  styleUrls: ['./verify-otp.component.scss']
})
export class VerifyOtpComponent implements OnInit, OnDestroy {
  @ViewChild('otpChild') otpChild: OtpComponent;

  @Input() methods: VerificationMethodModel[] = []
  @Input() token: string;
  @Input() state: OTP_STATE;
  @Input() isLoading: boolean = false;
  @Input() purpose: string;
  @Output() isLoadingChange = new EventEmitter<boolean>();
  @Output() stateChange = new EventEmitter<OTP_STATE>();
  @Output() accountLock = new EventEmitter<void>();
  @Output() verified = new EventEmitter<VerifyPINResponse>();

  public elementId = 'verify-otp';
  public sendingRequestOtp = false;
  public errorMessage: string;
  public requiredSetPin: boolean = false;
  public lang: string;
  public OTP_STATE = OTP_STATE;

  public selectedVerifyMethod: VerificationMethodModel
  public otpReference = "";
  public sessionExpired = false;

  private selectedVerifyMethodMap: Map<String, RequestOTPResponse> = new Map()
  private verifyPinSubscription: Subscription;
  private langSubscription: Subscription;
  private isAccountLocked = false;

  constructor(
    private translatePipe: TranslatePipe,
    private authenticationService: AuthenticationService,
    private appConfigService: AppConfigService,
    private userService: UserService,
    private dialog: MdDialog
  ) { }

  ngOnDestroy(): void {
    this.verifyPinSubscription && this.verifyPinSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.subscribeLanguageChanges()
  }

  subscribeLanguageChanges(): void {
    this.lang = this.appConfigService.getLanguage();
    this.langSubscription && this.langSubscription.unsubscribe();
    this.langSubscription = this.appConfigService.getLanguageObs().subscribe(lang => {
      this.lang = lang;
    });
  }

  onSubmit() {
    if (this.isAccountLocked) {
      this.userService.logout()
    }
    const verifyOTPRequest: VerifyOTPRequest = {
      otp: this.otpChild.getOtp(),
      referenceCode: this.otpReference,
      token: this.token
    }
    this.authenticationService.verifyOTP(verifyOTPRequest).subscribe(res => {
      this.isLoading = false;
      this.isLoadingChange.emit(this.isLoading);
      if (res) {
        this.errorMessage = undefined;
      } else {
        this.handleError();
      }
      this.verified.emit(res)
    }, (errRes) => {
      this.isLoading = false;
      this.isLoadingChange.emit(this.isLoading);
      this.handleError(errRes);
    });
  }

  handleInvalidOTP(message: string) {
    const match = message.match(/\{(\d+)\}/);
    if (match && match[1]) {
      const remaining = +match[1];
      if (remaining <= 1) {
        this.errorMessage = this.translatePipe.transform('otp-last-attempts');
      } else if (remaining <= 3) {
        this.errorMessage = this.translatePipe.transform('otp-remaining-attempts').replace('{x}', remaining);
      }
    }
  }

  handleError(errRes?: any) {
    if (errRes) {
      if (errRes.status === 400) {
        this.errorMessage = this.translatePipe.transform('otp-code-incorrect');
        const errorData = errRes.json();
        if (errorData.errors && errorData.errors.length > 0) {
          this.handleInvalidOTP(errorData.errors[0].message);
        } else {
          this.showDialogError();
        }
      } else if (errRes.status === 401) {
        this.errorMessage = this.translatePipe.transform('session-expired');
        this.sessionExpired = true;
        this.state = this.OTP_STATE.SESSION_EXPIRE;
        this.stateChange.emit(this.state);
      } else if (errRes.status === 403) {
        this.isAccountLocked = true;
        this.errorMessage = this.translatePipe.transform('account-locked');
        this.accountLock.emit()
      }
    } else {
      this.showDialogError();
    }
  }

  get otpInputForm() {
    if (this.otpChild) {
      return this.otpChild.otpInputForm;
    }
    return undefined;
  }

  onSelectOtpMethod(method: VerificationMethodModel) {
    if (this.selectedVerifyMethodMap.has(method.method)) {
      const requestOtpResponse = this.selectedVerifyMethodMap.get(method.method)
      this.otpReference = requestOtpResponse.referenceCode;
      this.selectedVerifyMethod = requestOtpResponse.methods;
      this.state = this.OTP_STATE.OTP;
      this.stateChange.emit(this.state);
    } else {
      this.requestOTP(method);
    }
  }

  requestOTP(method: VerificationMethodModel) {
    const otpRequest: OTPRequest = {
      lang: this.lang,
      methods: method,
      purpose: this.purpose,
      token: this.token
    }
    this.sendingRequestOtp = true;
    this.authenticationService.requestOTP(otpRequest).subscribe((res) => {
      this.selectedVerifyMethodMap.set(method.method, res)
      this.selectedVerifyMethod = res.methods;
      this.otpReference = res.referenceCode;
      this.sendingRequestOtp = false;
      this.state = this.OTP_STATE.OTP;
      this.stateChange.emit(this.state);
    }, (error) => {
      this.sendingRequestOtp = false;
      this.handleError(error);
    })
  }

  showDialogError() {
    const dialogRef: MdDialogRef<DialogErrorComponent> = this.dialog.open(DialogErrorComponent);
    dialogRef.componentInstance.text = this.translatePipe.transform('system-error');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/verify-otp/verify-otp.component.ts